import { injectGlobal } from 'styled-components';
import { PRIMARY_COLOR, BACKGROUND_DARK, BACKGROUND_DARK2 } from './constants';

/* eslint no-unused-expressions: 0 */
injectGlobal`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  body.fontLoaded {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #app {
    background-color: #fafafa;
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: Georgia, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }

  .green{
    background-color: ${PRIMARY_COLOR} !important;
  }

  .grey{
    background-color: ${BACKGROUND_DARK2} !important;
  }

  .inverted{
    background-color: ${BACKGROUND_DARK} !important;
  }

  .ui.steps .step.active .title{
    color: ${PRIMARY_COLOR} !important;
  }

  .ui.green.label, .ui.green.labels .label {
    background-color: ${PRIMARY_COLOR} !important;
    border-color: ${PRIMARY_COLOR} !important;
    color: rgb(255, 255, 255) !important;
}

.ui.green.labels .label:hover, a.ui.green.label:hover {
  background-color: ${PRIMARY_COLOR} !important;
    border-color: ${PRIMARY_COLOR} !important;
    color: rgb(255, 255, 255) !important;
}

.ui.green.ribbon.label, .ui.green.ribbon.label:hover {
  border-color: #3b9b73!important;
}

i.green.icon {
  color: ${PRIMARY_COLOR} !important;
  background-color: transparent !important;
}

.ui.green.active.compact.toggle.button{
  background-color: ${PRIMARY_COLOR} !important;
}

.ui.list>.item a.header {
  color: ${PRIMARY_COLOR} !important;
}

.ui.list>.item a.header:hover {
  color: ${PRIMARY_COLOR} !important;
}


.image_wrapper{
  display: block;
width: 100%;
height: auto;
position: relative;
overflow: hidden;
padding: 56.25% 0 0 0;
}
.image_wrapper img{
  display: block;
max-width: 100%;
max-height: 100%;
position: absolute !important;
top: 0;
bottom: 0;
left: 0;
right: 0;
}

.audory_loader_bg{
  width: 100%;
  height: 100%;
  background-color: #88ddba;
  z-index: -2;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.audory_loader {
  position: absolute;
  z-index: -1;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  top: calc(50% - 30px);
  left: calc(50% - 30px);
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid #4d9879; /* Blue */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;


// WEBPACK FOOTER //
// ./src/global-styles.js